import * as React from 'react';
import { useState, useEffect } from 'react';
import Box from '@mui/joy/Box';
import Typography from '@mui/joy/Typography';
import Stack from '@mui/joy/Stack';
import { Outlet, useLocation } from 'react-router-dom';
import TuneIcon from '@mui/icons-material/Tune';
import History from "../components/History";

const PoliciesPage = () => {
    const location = useLocation();
    const [isPolicySetup, setIsPolicySetup] = useState(false);

    useEffect(() => {
        const isWizard = location.pathname.includes("wizard");
        setIsPolicySetup(isWizard);
    }, [location.pathname]);

    return (
        <Box
            component="main"
            className="MainContent"
            sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
            }}
        >
            {/* Header Section */}
            <Stack sx={{ px: { xs: 2, md: 4 }, pt: '0.5%', flexShrink: 0 }}>
                <Box sx={{ mb: 1 }}>
                    <History />
                </Box>
                {/* Page Header - only show when not in policy setup/wizard mode */}
                {!isPolicySetup && (
                    <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        alignItems={{ xs: 'flex-start', sm: 'center' }}
                        justifyContent="space-between"
                        spacing={2}
                        sx={{ mb: 1 }}
                    >
                        <Stack direction="row" alignItems="center" spacing={2}>
                            <Box
                                sx={{
                                    width: 48,
                                    height: 48,
                                    borderRadius: 'lg',
                                    background: (theme) =>
                                        `linear-gradient(135deg, ${theme.vars.palette.primary[400]} 0%, ${theme.vars.palette.primary[600]} 100%)`,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    boxShadow: 'sm',
                                }}
                            >
                                <TuneIcon sx={{ fontSize: 28, color: 'white' }} />
                            </Box>
                            <Box>
                                <Typography level="h2" component="h1">
                                    Document flows
                                </Typography>
                                <Typography level="body-sm" color="neutral">
                                    Define extraction rules and document field schemas
                                </Typography>
                            </Box>
                        </Stack>
                    </Stack>
                )}
            </Stack>

            {/* Main Content */}
            <Box sx={{ flex: 1, minHeight: 0, overflow: 'hidden', display: 'flex', flexDirection: 'column', px: { xs: 2, md: 4 }, py: 1 }}>
                <Outlet />
            </Box>
        </Box>
    );
};

export default PoliciesPage;    
